import React from "react";

type ContainerProps = {
    children: any;
    className?: string;
};

const Container: React.FC<ContainerProps> = ({ children, className = '' }) => {
    return (
        <div className={`${className} m-auto max-w-[1280px] px-[10px] md:px-4 lg:px-7 xl:px-0`}>
            {children}
        </div>
    );
};

export default Container;
